import React from 'react';
import { useIntl } from 'react-intl';

import {
  TXTCLI_1_day,
  TXTCLI_1_hour,
  TXTCLI_1_min,
  TXTCLI_N0_days,
  TXTCLI_N0_hours,
  TXTCLI_N0_min
} from './TimeUnits.messages.json';

interface Props {
  days?: number;
  hours?: number;
  minutes?: number;
}
const TimeUnits: React.FC<Props> = ({ days, hours, minutes }) => {
  const { formatMessage } = useIntl();

  const result = [];

  if (days && days > 1) {
    result.push(formatMessage(TXTCLI_N0_days, { 0: days }));
  } else if (days === 1) {
    result.push(formatMessage(TXTCLI_1_day));
  }

  if (hours && hours > 1) {
    result.push(formatMessage(TXTCLI_N0_hours, { 0: hours }));
  } else if (hours === 1) {
    result.push(formatMessage(TXTCLI_1_hour));
  }

  if (minutes && minutes > 1) {
    result.push(formatMessage(TXTCLI_N0_min, { 0: minutes }));
  } else if (minutes === 1) {
    result.push(formatMessage(TXTCLI_1_min));
  }

  if (!result.length) {
    return null;
  }

  return <>{result.join(' ')}</>;
};

export default TimeUnits;
